import { ProduceBanners } from './components/ProduceBanners';
import { useLocation } from 'react-router-dom';
import { useFetchBannerById } from '../../../data/swrs/banners';
import api from '../../../data/api';
import dayjs from 'dayjs';

const EditBanners = () => {
	//get banner id from url using useLocation
	const location = useLocation();
	const bannerId = location.pathname.split('/')[3];

	const { data: bannerDetails, error } = useFetchBannerById(bannerId);

	if (error) {
		return <div>{'Something Went Wrong'}</div>;
	}

	const initialValues = {
		_id: bannerDetails?.data?._id,
		title: bannerDetails?.data?.title,
		image: bannerDetails?.data?.image,
		isActive: bannerDetails?.data?.isActive,
		releaseDate: bannerDetails?.data?.releaseDate ? dayjs(bannerDetails?.data?.releaseDate).format('YYYY-MM-DD') : new Date(),
		dateOnly: bannerDetails?.data?.releaseDate ? dayjs(bannerDetails?.data?.releaseDate).format('YYYY-MM-DD') : new Date(),
	};

	const handleSubmit = async (bannerData) => {
		return await api.editBannerApi(bannerData);
	};

	return <ProduceBanners initialValues={initialValues} onSubmit={handleSubmit} />;
};

export default EditBanners;
